import { createContext, ReactNode } from 'react';
import { ResponseActionScope } from '../types/context';

export const ResponseActionsScopeContext =
  createContext<ResponseActionScope>('dataset');

const ResponseActionsScopeProvider = ({
  scope,
  children,
}: {
  scope: ResponseActionScope;
  children: ReactNode;
}) => (
  <ResponseActionsScopeContext.Provider value={scope}>
    {children}
  </ResponseActionsScopeContext.Provider>
);

export default ResponseActionsScopeProvider;
